export default __webpack_public_path__ + "static/media/test4.f0119768.jpg";